module.exports = {
      id: "videographer-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#videographer",
      toString: function () {
        return this.url;
      }
    }